<template>
  <v-expansion-panel :value="expandByDefault" :disabled="disable">
    <v-expansion-panel-content v-for="(item,i) in 1" :key="i">
      <div slot="header" v-if="stringFiltersSelected.length < 20">{{stringFiltersSelected}}</div>
      <div slot="header" v-else>{{stringFiltersSelected.substr(0,19)+ '...'}}</div>
      <v-treeview
        v-model="filtersSelected"
        :items="filtersToItems"
        :disabled="disable"
        activatable
        active-class="grey lighten-4 indigo--text"
        selected-color="indigo"
        open-on-click
        selectable
        return-object
        expand-icon="chevron_right"
        on-icon="check_box"
        off-icon="check_box_outline_blank"
        indeterminate-icon="indeterminate_check_box"
      ></v-treeview>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mapGetters } from "vuex";
import { groupBy } from "@/shared/utility.js";

export default {
  name: "ExpendableTags",
  props: {
    expandByDefault: {
      default: null,
      type: Number
    },
    cleanFilters: Boolean,
    disable: Boolean,
    properties: Object,
    preselection: Array,
    excludeGroup: {
      default: null,
      type: String
    },
    showOnlyOne: {
      default: Array,
      type: Array
    },
    showOnlySelected: {
      default: Array,
      type: Array
    }
  },
  data() {
    return {
      tree: [],
      stringFiltersSelected: "",
      filtersSelected: []
    };
  },
  methods: {
    searchInner(node, array) {
      if (node.Description == array.name && node.Selected == "yes" && node.TagId == array.id) {
        this.filtersSelected.push(array);
      } else if (array.children !== undefined && array.children.length > 0) {
        array.children.forEach(c => {
          this.searchInner(node, c);
        });
      } else {

      }
    }
  },
  watch: {
    // properties: {
    //   handler: function(v) {
    //   },
    //   deep: true
    // },
    cleanFilters(newV, oldV) {
      if (newV == true) {
        this.filtersSelected = [];
      }
    },
    preselection(newV, oldV) {
      this.filtersSelected = [];
      newV.forEach(e => {
        this.filtersToItems.forEach(curArray => {
          this.searchInner(e, curArray);
        });
      });
    },
    filtersSelected(newV, oldV) {
      this.stringFiltersSelected = newV
        .filter(i => i.children.length == 0)
        .map(e => e.name)
        .join();
      const copyTags = JSON.parse(JSON.stringify(newV));
      const groupByGroup = groupBy("group");
      const groupedTags = groupByGroup(copyTags);
      let _tags2 = {};
      for (let [k, v] of Object.entries(groupedTags)) {
        _tags2[k] = {};
        v.forEach(i => {
          if (i.id != i.group) _tags2[k][i.id] = Number(i.id);
        });
      }

      // adding unselected taggroups
      this.filtersToItems.forEach(e => {
        if (_tags2[e.name] == undefined) {
          _tags2[e.name] = {};
        }
      });
      this.$emit("returnedTagsData", this.stringFiltersSelected);
      this.$emit("selectedTags", _tags2);
    }
  },
  mounted() {
    if (this.preselection !== undefined) {
      this.preselection.forEach(e => {
        this.filtersToItems.forEach(curArray => {
          this.searchInner(e, curArray);
        });
      });
    }
  },
  computed: {
    ...mapGetters({
      filters: "getFilterTags"
    }),
    filtersToItems() {
      this.tree = [];

      // this.filters.filter(g => this.excludeGroup == null || (this.excludeGroup != null && g.title != this.excludeGroup) ).map(e => {
      if (this.showOnlyOne.length === 0) {
        this.filters
          .filter(g => {
            if (this.showOnlySelected.length == 0) {
              return true;
            }
            if (
              this.showOnlySelected.length > 0 &&
              g.title == this.showOnlySelected[0]
            ) {
              if (
                this.preselection.filter(
                  e => e.TagGroup == this.showOnlySelected[0]
                ).length > 0
              ) {
                return true;
              } else return false;
            }

            return true;
          })
          .map(e => {
            const children = e.entries
              .filter(f => {
                return (
                  this.showOnlySelected.length == 0 ||
                  (this.showOnlySelected.length > 0 &&
                    this.preselection.filter(
                      z => z.TagId == f.k && f.group == this.showOnlySelected[0]
                    ).length > 0) ||
                  (this.showOnlySelected.length > 0 &&
                    f.group != this.showOnlySelected[0])
                );
              })
              .map(i => ({
                id: i.k,
                name: i.v,
                children: [],
                group: e.title
              }));
            this.tree.push({
              id: e.title,
              name: e.title,
              children: children,
              group: e.title
            });
          });
      } else {
        this.filters
          .filter(g => {
            if (this.showOnlyOne.length === 0) {
              return true;
            }
            if (
              this.showOnlyOne.length > 0 &&
              g.title !== this.showOnlyOne[0]
            ) {
              if (
                this.preselection.filter(
                  e => e.TagGroup === this.showOnlySelected[0]
                ).length > 0
              ) {
                return true;
              } else return false;
            }

            return true;
          })
          .map(e => {
            const children = e.entries
              .filter(f => {
                return (
                  this.showOnlyOne.length === 0 ||
                  (this.showOnlyOne.length > 0 &&
                    this.preselection.filter(
                      z => z.TagId === f.k && f.group !== this.showOnlyOne[0]
                    ).length > 0) ||
                  (this.showOnlyOne.length > 0 &&
                    f.group === this.showOnlyOne[0])
                );
              })
              .map(i => ({
                id: i.k,
                name: i.v,
                children: [],
                group: e.title
              }));
            children.forEach( a => {
              this.tree.push({
                id: a.id,
                name: a.name,
                children: a.children,
                group: a.group
              });
            });
          });
      }

      return this.tree;
    }
  }
};
</script>
